var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.chips, function(val, key) {
      return _c(
        "v-chip",
        {
          key: key,
          attrs: { close: "", color: "background darken-1" },
          on: {
            input: function($event) {
              return _vm.removefilter(key)
            }
          }
        },
        [
          _c("span", { staticClass: "background--text text--lighten-5 mr-1" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.getChipLabel(key)) + "\n\t\t")
          ]),
          _vm._v("\n\t\t" + _vm._s(_vm._f("substring")(val, 0, 24)) + "\n\t")
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae994b60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae994b60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/filesystem/title_asset_finder_filters_chips.vue
// module id = null
// module chunks = 